export default "__VITE_ASSET__CXTBm7J$__"